import { func } from 'prop-types';
import { Component } from 'react';
import Dropzone from 'react-dropzone';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ErrorCircle from 'shared/components/icon/ErrorCircle';
import Upload from 'shared/components/icon/Upload';
import {
  clearArchiveUploadError,
  showAlertDialog,
  uploadBet,
} from 'shared/redux/actions';
import { archiveUpload } from 'shared/redux/selectors';
import { getText } from 'shared/utils/Text';

const mapStateToProps = state => ({
  numUploaded: archiveUpload.getUploadCount(state),
  uploadError: archiveUpload.getError(state),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { uploadBet, clearArchiveUploadError, showAlertDialog },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  class ArchiveUpload extends Component {
    static propTypes = {
      uploadBet: func.isRequired,
      onFileUploaded: func.isRequired,
    };

    state = {
      fileError: '',
    };

    componentDidUpdate(prevProps) {
      const { numUploaded, onFileUploaded } = this.props;
      if (numUploaded > prevProps.numUploaded) {
        onFileUploaded();
      }
    }

    componentWillUnmount() {
      this.props.clearArchiveUploadError();
    }

    onFileChangeDrop = acceptedFiles => {
      if (acceptedFiles.length > 1) {
        this.setState({
          fileError: getText('dialog-archive-multi-file'),
        });
        return;
      } else if (
        acceptedFiles.length === 0 ||
        acceptedFiles[0].name.split('.').pop() !== 'jokersystem'
      ) {
        this.setState({
          fileError: getText('dialog-archive-file-invalid-extension'),
        });
        return;
      } else {
        this.setState({
          fileError: '',
        });
      }

      const file = acceptedFiles[0];
      const data = new FormData();
      data.append('file', file);
      data.append('name', file.name);
      this.props.uploadBet(data);
    };

    showConfirm() {
      const { showAlertDialog } = this.props;
      showAlertDialog({
        title: getText('dialog-archive-file-upload'),
      });
    }

    render() {
      const { uploadError } = this.props;
      const { fileError } = this.state;

      return (
        <div className="archive-upload">
          <div className="text-small">
            {getText('dialog-archive-upload-info')}
          </div>
          <hr />
          <div>
            {(uploadError || fileError) && (
              <div className="error-info editorial error-info--small">
                <ErrorCircle className="with-heading" />
                <div>
                  <p className="text-small">
                    {uploadError != null
                      ? getText('dialog-archive-upload-error')
                      : fileError}
                  </p>
                </div>
              </div>
            )}

            <Dropzone
              accept={{
                'text/plain': ['.jokersystem'],
              }}
              multiple={false}
              onDrop={acceptedFiles => {
                this.onFileChangeDrop(acceptedFiles);
              }}
            >
              {({ getRootProps, getInputProps }) => (
                <div className="drop-zone">
                  <div {...getRootProps()}>
                    <div>
                      <input {...getInputProps()} />
                    </div>
                    <p className="text-small">
                      {getText('dialog-archive-upload')}
                    </p>

                    <div className="item-button__inner">
                      <div className="item-button__icon">
                        <Upload />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Dropzone>
          </div>
        </div>
      );
    }
  },
);
